import { useStaticQuery, graphql } from 'gatsby'
import EventList from '../../utils/EventList'

const AllEvents = () => {
    const { allWpEvent } = useStaticQuery(
        graphql`
            query {
                allWpEvent(
                    sort: { startDate: ASC }
                    filter: { privatePost: { isprivate: { ne: true } } }
                ) {
                    nodes {
                        databaseId
                        title
                        excerpt
                        link
                        url
                        featured
                        featuredImage {
                            node {
                                localFile {
                                    ...CardImage
                                }
                            }
                        }
                        eventsCategories {
                            nodes {
                                name
                                slug
                                url: uri
                            }
                        }
                        products {
                            nodes {
                                slug
                                name
                            }
                        }
                        eventDetails {
                            eventFullSoldOut
                            eventFullText
                            eventlocationDetails
                            registrationUrl
                            questions
                            eventFormat
                            timeZoneInfoFreeText
                        }
                        endDate
                        startDate
                        cost
                        organizers {
                            nodes {
                                title
                            }
                        }
                        timezone
                        venue {
                            address
                            city
                            state
                            zip
                            title
                            content
                            latitude
                            longitude
                        }
                    }
                }
            }
        `,
    )
    
    let validEvents = new EventList(allWpEvent.nodes, { sort: true })
    return validEvents
}

export default AllEvents
